import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaSyncAlt, FaWifi } from 'react-icons/fa';

export const DisconnectedContent = () => {
  return (
    <ChakraV3.Stack maxW='md' gap={6} alignSelf='center' align='center' textAlign='center'>
      <ChakraV3.Square size='16' rounded='2xl' bg='red.50'>
        <ChakraV3.Icon color='red.400' boxSize='10'>
          <FaWifi />
        </ChakraV3.Icon>
      </ChakraV3.Square>
      <ChakraV3.Text fontWeight='bold' fontSize='4xl'>
        You are offline
      </ChakraV3.Text>
      <ChakraV3.Text fontSize='xl' fontWeight='semibold' color='gray.600'>
        It seems there was a problem with your connection. Please check your network status.
      </ChakraV3.Text>
      <ChakraV3.Button onClick={() => window.location.reload()} w='full' variant='subtle' size='sm'>
        <FaSyncAlt />
        Refresh to reconnect
      </ChakraV3.Button>
    </ChakraV3.Stack>
  );
};
